import { IconButton, Tooltip } from '@mui/material';
import { useState } from 'react'
import CustomButton from 'components/buttons/CustomButton/CustomButton';
import { colors } from 'styles/colors';
import { snackbarService } from 'services/snackbarService';
import CustomDialog from 'components/dialogs/CustomDialog';
import { useRejectInvitation } from 'hooks/useUsers';
import { useAuth } from 'context/AuthContext';
import LogoutIcon from '@mui/icons-material/Logout';

interface Props {
    doctorId: number;
    refetch?: () => void;
}

function LeaveDashboardActionButton({ doctorId, refetch }: Props) {
    const { user } = useAuth();
    const [open, setOpen] = useState<boolean>(false);

    const { mutate: leaveMutation, isLoading } = useRejectInvitation(
        (data: any) => {
            setOpen(false);
            snackbarService.showSnackbar('Dashboard leaved successfully', 'success');
            refetch?.();
        },
        (err: any) => {
            snackbarService.showSnackbar(err, 'error');
        },
    )

    const handleLeave = () => {
        leaveMutation({
            userId: user.id,
            doctorId,
        });
    }

    return (
        <>
            <Tooltip title={'Leave'}>
                <IconButton
                    onClick={() => setOpen(true)}
                    sx={{
                        width: 25,
                        height: 25,
                        backgroundColor: colors.error,
                        borderRadius: '4px',
                        padding: 0,
                        '&:hover': {
                            backgroundColor: colors.error,
                        },
                    }}
                >
                    <LogoutIcon sx={{ fontSize: 15, color: colors.white }} />
                </IconButton>
            </Tooltip>
            <CustomDialog
                open={open}
                title='Leave dashboard'
                message={`Are you sure you want to leave this dashboard?`}
                buttons={[
                    <CustomButton
                        key='cancel'
                        text="Cancel"
                        variant='outlined'
                        color='success'
                        onClick={() => setOpen(false)}
                        disabled={isLoading}
                    />,
                    <CustomButton
                        key='leave'
                        text="Leave"
                        color='error'
                        intent='error'
                        onClick={handleLeave}
                        loading={isLoading}
                    />
                ]}
            />
        </>
    )
}

export default LeaveDashboardActionButton;